import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'hearing_difficulty'

const OPTIONS = [
  {
    value: 'none',
    translationKey: 'pages.onboarding.hearingDifficulty.options.none',
  },
  {
    value: 'mild',
    translationKey: 'pages.onboarding.hearingDifficulty.options.mild',
  },
  {
    value: 'moderate',
    translationKey: 'pages.onboarding.hearingDifficulty.options.moderate',
  },
  {
    value: 'severe',
    translationKey: 'pages.onboarding.hearingDifficulty.options.severe',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '👂',
    title: 'pages.onboarding.hearingDifficulty.options.none',
    value: 'none',
  },
  {
    emoji: '🗣️',
    title: 'pages.onboarding.hearingDifficulty.options.mild',
    value: 'mild',
  },
  {
    emoji: '🔊',
    title: 'pages.onboarding.hearingDifficulty.options.moderate',
    value: 'moderate',
  },
  {
    emoji: '⚠️',
    title: 'pages.onboarding.hearingDifficulty.options.severe',
    value: 'severe',
  },
]

export default function HearingDifficultyPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you experience hearing difficulty in conversations?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.hearingDifficulty.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
